import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AccountDetailsPage, { getDefaultPageUI } from "components/pages/AccountDetailsPage";

export default function CaptureAccountsAmountDD(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchAccordion", "isActive" ], true)
        .update([ "searchByCheck" ], true)
        .submit();

    return <AccountDetailsPage ui={ ui } />
}